module.exports = "../images/icons/expand-icon.svg";